import api from '@/services/api';
import helpers from '@/services/helpers';

export default {
  getCompanies: ({ commit }, props) => {
    return api.getCompanies(props).then((response) => {
      commit('INIT_COMPANIES', response.data.data);
      if(!props?.skipPager) {
        commit('INIT_PAGER', response.data.pagedResult);
      }
      return response.data.data;
    });
  },
  getCompaniesV2: ({ commit }, props) => {
    return api.getCompaniesV2(props).then((response) => {
      commit('INIT_COMPANIES', response.data.data);
      if(!props?.skipPager) {
        commit('INIT_PAGER', response.data.pagedResult);
      }
      return response.data.data;
    });
  },
  getBrands: ({ commit }, payload) => {
    api.getBrands(payload).then((response) => {
      commit('INIT_BRANDS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCompany: ({ commit }, payload) => {
    return api.getCompanyById(payload).then((response) => {
      commit('SELECT_COMPANY', response.data.data);
      return response.data.data;
    });
  },
  getCompanySuperBonus: ({ commit }, payload) => {
    return api.getCompanySuperBonusByCompanyId(payload).then((response) => {
      commit('SELECT_COMPANY_SUPER_BONUS', response.data.data);
      return response.data.data;
    });
  },
  getSimplifiedCompanies: ({ commit }, payload) => {
    api.getSimplifiedCompanies(payload).then((response) => {
      commit('INIT_SIMPLIFIED_COMPANIES', response.data.data);
    });
  },
  getCompanyArticles: ({ commit }, companyId) => {
    return api.getCompanyArticles(companyId).then((response) => {
      commit('INIT_COMPANY_ARTICLES', response.data.data);
    });
  },
  getCommercialists: ({ commit }) => {
    api.getCommercialists().then((response) => {
      commit('INIT_COMMERCIALISTS', response.data.data);
    });
  },
  getMasterCompanies: ({ commit }) => {
    api.getMasterCompanies().then((response) => {
      commit('INIT_MASTER_COMPANIES', response.data.data);
    });
  },
  getCommercialistsForCompany: ({ commit }, companyId) => {
    api.getCommercialistsForCompany(companyId).then((response) => {
      commit('INIT_COMMERCIALISTS_FOR_COMPANIES', response.data.data);
    });
  },
  getTowns: ({ commit }, payload) => {
    return api.getTowns(payload).then((response) => {
      commit('INIT_TOWNS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
      return response.data.data;
    });
  },
  getTown: ({ commit }, id) => {
    api.getTown(id).then((response) => {
      commit('INIT_TOWN', response.data.data);
    });
  },
  getShippingTowns: ({ commit }, payload) => {
    api.getTowns(payload).then((response) => {
      commit('INIT_SHIPPING_TOWNS', response.data.data);
    });
  },
  getUsers: ({ commit }, payload) => {
    return api.getUsers(payload).then((response) => {
      commit('INIT_USERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
      return response.data.data;
    });
  },
  getUser: ({ commit }, id) => {
    return api.getUserById(id).then((response) => {
      commit('SELECT_USER', response.data.data);
      return response.data.data;
    });
  },
  getShippingInfoForUser: ({ commit }, id) => {
    return api.getShippingInfoForUserById(id).then((response) => {
      commit('SELECT_USER_SHIPPING_INFO', response.data.data);
    });
  },
  saveToken: ({ commit }, token) => {
    localStorage.setItem('token', token);
    commit('INIT_TOKEN', token);
  },
  storeProfileData: ({ commit }, payload) => {
    commit('INIT_PROFILE_DATA', payload);
    commit('INIT_LOGGED_USER_PERMISSIONS', payload.permissions);
  },
  getCountries: ({ commit }, props) => {
    return api.getCountries(props).then((response) => {
      commit('INIT_COUNTRIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
      return response.data.data;
    });
  },
  getCountry: ({ commit }, id) => {
    api.getCountry(id).then((response) => {
      commit('INIT_COUNTRY', response.data.data);
    });
  },
  getProfile: ({ commit }) => {
    return api.getProfile().then((response) => {
      commit('INIT_USER_PROFILE', response.data.data);
    });
  },

  // Categories
  getCategories: ({ commit }, payload) => {
    api.getCategories(payload).then((response) => {
      commit('INIT_CATEGORIES', helpers.generateCategories(response.data.data));
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getParentCategories: ({ commit }, payload) => {
    api.getParentCategories(payload).then((response) => {
      commit('INIT_PARENT_CATEGORIES', helpers.generateCategories(response.data.data));
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getChildCategories: ({ commit }, payload) => {
    api.getChildCategories(payload).then((response) => {
      commit('INIT_CHILD_CATEGORIES', helpers.generateCategories(response.data.data));
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getSimplifiedCategories: ({ commit }, payload) => {
    api.getSimplifiedCategories(payload).then((response) => {
      commit('INIT_SIMPLIFIED_CATEGORIES', response.data.data);
    });
  },
  getCategoryById: ({ commit }, payload) => {
    api.getCategoryById(payload).then((response) => {
      commit('INIT_CATEGORY', response.data.data[0]);
    });
  },
  getCategoryArticles: ({ commit }, payload) => {
    api.getCategoryArticles(payload).then((response) => {
      commit('INIT_CATEGORY_ARTICLES', response.data.data);
    });
  },
  getPriorityArticles: ({ commit }, payload) => {
    api.getPriorityArticles(payload).then((response) => {
      commit('INIT_CATEGORY_PRIORITY_ARTICLES', response.data.data);
    });
  },

  // Articles
  getArticles: ({ commit }, payload) => {
    return api.getArticles(payload).then((response) => {
      commit('INIT_ARTICLES', response.data.data.articles);
      commit('INIT_SEARCH_VARIATIONS', response.data.data.variations);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getPresentationRequests: ({ commit }, payload) => {
    api.getPresentationRequests(payload).then((response) => {
      commit('INIT_PRESENTATION_REQUESTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getArticleById: ({ commit }, payload) => {
    api.getArticleById(payload).then((response) => {
      commit('INIT_ARTICLE', response.data.data);
    });
  },
  makeCopyOfArticle: ({ commit }, payload) => {
    commit('INIT_COPY_OF_ARTICLE', payload);
  },
  getArticleFilters: ({ commit }) => {
    return api.getArticleFilters().then((response) => {
      commit('INIT_ARTICLE_FILTERS', response.data.data);
      return response.data.data;
    });
  },
  getBanks: ({ commit }, payload) => {
    api.getBanks(payload).then((response) => {
      commit('INIT_BANKS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getBank: ({ commit }, payload) => {
    api.getBank(payload).then((response) => {
      commit('INIT_BANK', response.data.data);
    });
  },
  getCurrencies: ({ commit }, payload) => {
    api.getCurrencies(payload).then((response) => {
      commit('INIT_CURRENCIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCurrency: ({ commit }, payload) => {
    api.getCurrency(payload).then((response) => {
      commit('INIT_CURRENCY', response.data.data);
    });
  },
  getMeasurementUnits: ({ commit }, payload) => {
    api.getMeasurementUnits(payload).then((response) => {
      commit('INIT_MEASUREMENT_UNITS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  getMeasurementUnit: ({ commit }, id) => {
    api.getMeasurementUnit(id).then((response) => {
      commit('INIT_MEASUREMENT_UNIT', response.data.data);
    });
  },
  getCompanySuperBonusPaged: ({ commit }, props) => {
    api.getCompanySuperBonusPaged(props).then((response) => {
      commit('INIT_SUPER_BONUS', response.data.data);
      // commit('INIT_PAGER', response.data.pagedResult);
      return response.data.data;
    });
  },
  getBrand: ({ commit }, payload) => {
    api.getBrand(payload).then((response) => {
      commit('INIT_BRAND', response.data.data);
    });
  },
  getTaxes: ({ commit }, payload) => {
    api.getTaxes(payload).then((response) => {
      commit('INIT_TAXES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getExpressPosts: ({ commit }, payload) => {
    api.getExpressPosts(payload).then((response) => {
      commit('INIT_EXPRESS_POSTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
      return response.data.data;
    });
  },
  getExpressPost: ({ commit }, payload) => {
    return api.getExpressPost(payload).then((response) => {
      commit('INIT_EXPRESS_POST', response.data.data);
      return response.data.data;
    });
  },

  // Tabs
  getTabs: ({ commit }, payload) => {
    api.getTabs(payload).then((response) => {
      commit('INIT_TABS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getTab: ({ commit }, payload) => {
    api.getTab(payload).then((response) => {
      commit('INIT_TAB', response.data.data);
    });
  },

  // Product sales
  getProductSales: ({ commit }, payload) => {
    api.getProductSales(payload).then((response) => {
      commit('INIT_PRODUCT_SALES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getProductSale: ({ commit }, id) => {
    api.getProductSale(id).then((response) => {
      commit('INIT_PRODUCT_SALE', response.data.data);
    });
  },

  // Interests areas
  getInterestsAreas: ({ commit }, payload) => {
    return api.getInterestsAreas(payload).then((response) => {
      commit('INIT_INTERESTS_AREAS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
      return response.data.data;
    });
  },
  getInterestsArea: ({ commit }, id) => {
    api.getInterestsArea(id).then((response) => {
      commit('INIT_INTERESTS_AREA', response.data.data);
    });
  },

  // Customer bank accounts
  getCustomerBankAccounts: ({ commit }, payload) => {
    api.getCustomerBankAccounts(payload).then((response) => {
      commit('INIT_CUSTOMER_BANK_ACCOUNTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCustomerBankAccount: ({ commit }, id) => {
    api.getCustomerBankAccount(id).then((response) => {
      commit('INIT_CUSTOMER_BANK_ACCOUNT', response.data.data);
    });
  },

  // Blogs
  getBlogs: ({ commit }, payload) => {
    api.getBlogs(payload).then((response) => {
      commit('INIT_BLOGS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getBlog: ({ commit }, id) => {
    api.getBlog(id).then((response) => {
      commit('INIT_BLOG', response.data.data);
    });
  },
  makeCopyOfBlog: ({ commit }, payload) => {
    commit('INIT_COPY_OF_BLOG', payload);
  },

  // Newsletter
  getNewsletters: ({ commit }, payload) => {
    api.getNewsletters(payload).then((response) => {
      commit('INIT_NEWSLETTERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Terms of services
  getTermsOfServices: ({ commit }) => {
    api.getTermsOfServices().then((response) => {
      commit('INIT_TERMS_OF_SERVICES', response.data.data);
    });
  },

  // Attributes
  getAttributes: ({ commit }, payload) => {
    api.getAttributes(payload).then((response) => {
      commit('INIT_ATTRIBUTES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getAttribute: ({ commit }, id) => {
    api.getAttribute(id).then((response) => {
      commit('INIT_ATTRIBUTE', response.data.data);
    });
  },
  getAttributesByIds: ({ commit }, ids) => {
    api.getAttributesByIds(ids).then((response) => {
      commit('INIT_ATTRIBUTE_VALUES', response.data.data);
    });
  },
  getArticleVariations: ({ commit }, id) => {
    api.getArticleVariations(id).then((response) => {
      commit('INIT_ARTICLE_VARIATIONS', response.data.data);
    });
  },
  getVariationsWarehouseTowns: ({ commit }, id) => {
    api.getVariationsWarehouseTownsByArticleId(id).then((response) => {
      commit('INIT_VARIATIONS_WAREHOUSE_TOWNS', response.data.data);
    });
  },

  // System messages
  getSystemMessages: ({ commit }, payload) => {
    api.getSystemMessages(payload).then((response) => {
      commit('INIT_SYSTEM_MESSAGES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getSystemMessagesAsAdmin: ({ commit }, payload) => {
    api.getSystemMessagesAsAdmin(payload).then((response) => {
      commit('INIT_SYSTEM_MESSAGES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Highlighted brands
  getHighlightedBrands: ({ commit }, payload) => {
    api.getHighlightedBrands(payload).then((response) => {
      commit('INIT_HIGHLIGHTED_BRANDS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getHighlightedBrand: ({ commit }, id) => {
    api.getHighlightedBrand(id).then((response) => {
      commit('INIT_HIGHLIGHTED_BRAND', response.data.data);
    });
  },

  // Jumbotrons
  getJumbotrons: ({ commit }, payload) => {
    api.getJumbotrons(payload).then((response) => {
      commit('INIT_JUMBOTRONS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getJumbotronById: ({commit}, payload) => {
    api.getJumbotronById(payload).then((response) => {
      commit('INIT_JUMBOTRON', response.data.data);
    });
  },
  getHighlightedCategories: ({ commit }, payload) => {
    api.getHighlightedCategories(payload).then((response) => {
      commit('INIT_HIGHLIGHTED_CATEGORIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getHighlightedCategory: ({ commit }, id) => {
    api.getHighlightedCategory(id).then((response) => {
      commit('INIT_HIGHLIGHTED_CATEGORY', response.data.data);
    });
  },
  getBanners: ({ commit }, payload) => {
    api.getBanners(payload).then((response) => {
      commit('INIT_BANNERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getBanner: ({ commit }, id) => {
    api.getBanner(id).then((response) => {
      commit('INIT_BANNER', response.data.data);
    });
  },
  deleteBanners: (context, ids) => {
    return Promise.all((ids || []).map((id) => api.deleteBanner(id)));
  },
  getNewlyAddedArticles: ({ commit }, payload) => {
    api.getNewlyAddedArticles(payload).then((response) => {
      commit('INIT_NEWLY_ADDED_ARTICLES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Tags
  getArticleTags: ({ commit }) => {
    return api.getArticleTags().then((response) => {
      commit('INIT_ARTICLE_TAGS', response.data.data);
    });
  },
  getTags: ({ commit }, payload) => {
    api.getTags(payload).then((response) => {
      commit('INIT_TAGS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getTag: ({ commit }, payload) => {
    api.getTag(payload).then((response) => {
      commit('INIT_TAG', response.data.data);
    });
  },

  // Shopping carts
  getShoppingCarts: ({ commit }, payload) => {
    api.getShoppingCarts(payload).then((response) => {
      commit('INIT_SHOPPING_CARTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getShoppingCartArticles: ({ commit }, payload) => {
    api.getShoppingCartArticles(payload).then((response) => {
      commit('INIT_SHOPPING_CART_ARTICLES', response.data.data);
    });
  },

  // Wish lists
  getWishLists: ({ commit }, payload) => {
    api.getWishLists(payload).then((response) => {
      commit('INIT_WISH_LISTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    })
  },
  getWishListItems: ({ commit }, payload) => {
    api.getWishListItems(payload).then((response) => {
      commit('INIT_WISH_LIST_ARTICLES', response.data.data);
    })
  },

  // Orders
  getOrders: ({ commit }, payload) => {
    api.getOrders(payload).then((response) => {
      commit('INIT_ORDERS', response.data.data)
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getOrder: ({ commit }, payload) => {
    return api.getOrder(payload).then((response) => {
      commit('INIT_ORDER', response.data.data)
      return response.data.data;
    });
  },
  getOrderStates: ({ commit }, payload) => {
    api.getOrderStates(payload).then((response) => {
      commit('INIT_ORDER_STATES', response.data.data);
    });
  },
  mergeOrders: ({ commit }, payload) => {
    api.mergeOrders(payload).then((response) => {
      commit('INIT_MERGE_ORDERS', response.data.data);
    });
  },

  // Roles
  getRoles: ({ commit }, payload) => {
    api.getRoles(payload).then((response) => {
      commit('INIT_ROLES', response.data.data)
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  getRolesSimplified: ({ commit }, payload) => {
    api.getRolesSimplified(payload).then((response) => {
      commit('INIT_ROLES_SIMPLIFIED', response.data.data);
    });
  },

  getRole: ({ commit }, payload) => {
    api.getRole(payload).then((response) => {
      commit('INIT_ROLE', response.data.data)
    });
  },

  // Permissions
  getPermissions: ({ commit }) => {
    api.getPermissions().then((response) => {
      commit('INIT_PERMISSIONS', response.data.data);
    });
  },

  // Service managers
  getServiceManagers: ({ commit }, payload) => {
    api.getServiceManagers(payload).then((response) => {
      commit('INIT_SERVICE_MANAGERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getServiceManager: ({ commit }, payload) => api.getServiceManager(payload).then((response) => {
    commit('INIT_SERVICE_MANAGER', response.data.data);
    return response.data.data;
  }),

  // Customer files
  getCustomerFiles: ({ commit }, payload) => {
    api.getCustomerFiles(payload).then((response) => {
      commit('INIT_CUSTOMER_FILES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  getCustomerFileAsAdmin: ({ commit }, payload) => {
  api.getCustomerFileAsAdmin(payload).then((response) => {
    commit('INIT_CUSTOMER_FILE', response.data.data);
    });
  },

  // Complaints
  getComplaints: ({ commit }, payload) => {
    api.getComplaints(payload).then((response) => {
      commit('INIT_COMPLAINTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getComplaint: ({ commit }, id) => {
    api.getComplaint(id).then((response) => {
      commit('INIT_COMPLAINT', response.data.data);
    });
  },

  // Media library
  getMediaLibrary: ({ commit }, payload) => {
    api.getMediaLibrary(payload).then((response) => {
      commit('INIT_MEDIA_LIBRARY', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Meta SEO
  getMetaSeo: ({ commit }, payload) => {
    api.getMetaSeo(payload).then((response) => {
      commit('INIT_META_SEO', response.data.data);
    });
  },

  // Reviews
  getReviews: ({ commit }, payload) => {
    api.getReviews(payload).then((response) => {
      commit('INIT_REVIEWS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getReview: ({ commit }, payload) => {
    api.getReview(payload).then((response) => {
      commit('INIT_REVIEW', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Promo codes
  getPromoCodes: ({ commit }, payload) => {
    api.getPromoCodes(payload).then((response) => {
      commit('INIT_PROMO_CODES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getPromoCode: ({ commit }, payload) => {
    api.getPromoCode(payload).then((response) => {
      commit('INIT_PROMO_CODE', response.data.data);
    });
  },

  // Gift cards
  getGiftCards: ({ commit }, payload) => {
    api.getGiftCards(payload).then((response) => {
      commit('INIT_GIFT_CARDS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getGiftCard: ({ commit }, payload) => {
    return api.getGiftCard(payload).then((response) => {
      commit('INIT_GIFT_CARD', response.data.data);
    });
  },

  // Top brand list
  getTopBrandList: ({ commit }, payload) => {
    api.getTopBrandList(payload).then((response) => {
      commit('INIT_TOP_BRAND_LIST', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  getTopBrandListById: ({ commit }, payload) => {
    return api.getTopBrandListById(payload).then((response) => {
      commit('INIT_TOP_BRAND_LIST_SINGLE', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Offers
  getOffers: ({ commit }, payload) => {
    return api.getOffers(payload).then((response) => {
      commit('INIT_OFFERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getAdvancedOffers: ({ commit }, payload) => {
    return api.getAdvancedOffers(payload).then((response) => {
      commit('INIT_OFFERS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getOffer: ({ commit }, payload) => {
    return api.getOffer(payload).then((response) => {
      commit('INIT_OFFER', response.data.data);
      return response.data.data;
    });
  },
  getAdvancedOffer: ({ commit }, payload) => {
    return api.getAdvancedOffer(payload).then((response) => {
      commit('INIT_OFFER', response.data.data);
      return response.data.data;
    });
  },

  // Personal data change requests
  getPersonalDataChangeRequests: ({ commit }, payload) => {
    api.getPersonalDataChangeRequests(payload).then((response) => {
      commit('INIT_PERSONAL_DATA_CHANGE_REQUESTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getPersonalDataChangeRequest: ({ commit }, payload) => {
    api.getPersonalDataChangeRequest(payload).then((response) => {
      commit('INIT_PERSONAL_DATA_CHANGE_REQUEST', response.data.data);
    });
  },

  // Settings
  getSettings: ({ commit }, key) => {
    api.getSettings(key).then((response) => {
      commit('INIT_SETTINGS', JSON.parse(response.data.data.value));
    });
  },
  getShowOffers: ({ commit }) => {
    api.getShowOffers().then((response) => {
      commit('INIT_SHOW_OFFERS', response.data.data);
    });
  },
  getShowAdvancedOffers: ({ commit }) => {
    api.getShowAdvancedOffers().then((response) => {
      commit('INIT_SHOW_ADVANCED_OFFERS', response.data.data);
    });
  },

    // B2C Settings
    getB2CSettings: ({ commit }, key) => {
      api.getB2CSettings(key).then((response) => {
        commit('INIT_B2C_SETTINGS', JSON.parse(response.data.data.value));
      });
    },

  // Cleaning areas
  getCleaningAreas: ({ commit }, payload) => {
    api.getCleaningAreas(payload).then((response) => {
      commit('INIT_CLEANING_AREAS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getParentCleaningAreas: ({ commit }) => {
    return api.getCleaningAreas({
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
      retrieveOnlyParents: true,
    }).then((response) => {
      commit('INIT_PARENT_CLEANING_AREAS', response.data.data);
      return response.data.data;
    });
  },
  getCleaningAreaById: ({ commit }, id) => {
    api.getCleaningAreaById(id).then((response) => {
      commit('INIT_CLEANING_AREA', response.data.data);
    });
  },

  // Cleaning plan note icons
  getCleaningPlanNoteIcons: ({ commit }) => {
    api.getCleaningPlanNoteIcons().then((response) => {
      commit('INIT_CLEANING_PLAN_NOTE_ICONS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCleaningPlanNoteIcon: ({ commit }, id) => {
    api.getCleaningPlanNoteIcon(id).then((response) => {
      commit('INIT_CLEANING_PLAN_NOTE_ICON', response.data.data);
    });
  },

  // Cleaning plans
  getCleaningPlans: ({ commit }, payload) => {
    api.getCleaningPlans(payload).then((response) => {
      commit('INIT_CLEANING_PLANS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getCleaningPlan: ({ commit }, payload) => {
    return api.getCleaningPlan(payload).then((response) => {
      commit('INIT_CLEANING_PLAN', response.data.data);
      return response.data.data
    });
  },

  // Price policies
  getPricePolicies: ({ commit }, payload) => {
    api.getPricePolicies(payload).then((response) => {
      commit('INIT_PRICE_POLICIES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getPricePolicy: ({ commit }, payload) => {
    return api.getPricePolicy(payload).then((response) => {
      commit('INIT_PRICE_POLICY', response.data.data);
      return response.data.data;
    });
  },
  getDefaultPricePolicyTypes: ({ commit }) => {
    api.getDefaultPricePolicyTypes().then((response) => {
      commit('INIT_DEFAULT_POLICY_TYPES', response.data.data);
    });
  },
  getPricePolicyItems: ({ commit }, payload) => {
    api.getPricePolicyItems(payload).then((response) => {
      commit('INIT_PRICE_POLICY_ITEMS', response.data.data);
    });
  },

  // Dashboard
  getDashboardData: ({ commit }) => {
    api.getDashboardData().then((response) => {
      commit('INIT_DASHBOARD_DATA', response.data.data);
    });
  },

  // Out of stock articles
  getOutOfStockArticles: ({ commit }, payload) => {
    api.getOutOfStockArticles(payload).then((response) => {
      commit('INIT_OUT_OFF_STOCK_ARTICLES', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },
  getOutOfStockArticle: ({ commit }, payload) => {
    api.getOutOfStockArticle(payload).then((response) => {
      commit('INIT_OUT_OFF_STOCK_ARTICLE', response.data.data);
    });
  },

  // Customer requests
  getB2BCustomerRequests: ({ commit }, payload) => {
    api.getB2BCustomerRequests(payload).then((response) => {
      commit('INIT_CUSTOMER_REQUESTS', response.data.data);
      commit('INIT_PAGER', response.data.pagedResult);
    });
  },

  // Allowed document extensions
  getAllowedDocumentExtensions: ({ commit }) => {
    api.getAllowedDocumentExtensions().then((response) => {
      commit('INIT_ALLOWED_DOCUMENT_EXTENSIONS', response.data.data);
    });
  },
};
